import type { BombiixCellRendererParams, BombiixRow } from '../types';

interface ReadonlyTextCellExtras {
  accessor?: (row: BombiixRow | undefined) => unknown;
  fallback?: string;
}

type ReadonlyTextCellProps = BombiixCellRendererParams & ReadonlyTextCellExtras;

/**
 * Plain text cell — rendered when the grid (or the row) is in read-only mode,
 * or when a column declares cellType: 'readonlyText'.
 */
function ReadonlyTextCell(params: ReadonlyTextCellProps) {
  const { value, data, accessor, fallback = '--' } = params;
  const text = typeof accessor === 'function' ? accessor(data) : value;
  const display = text === undefined || text === null || text === '' ? fallback : String(text);
  return (
    <div className="cag-cell cag-cell-readonly">
      <span title={display}>{display}</span>
    </div>
  );
}

export default ReadonlyTextCell;
